import {
  EditOutlinedIcon,
  DeleteOutlinedIcon,
  SettingsOutlinedIcon,
  FileUploadOutlinedIcon,
  CheckCircleOutlinedIcon,
  PendingOutlinedIcon,
  ErrorOutlineOutlinedIcon,
  HelpOutlinedIcon,
  LinkOutlinedIcon,
  LinkOffOutlinedIcon,
  InfoOutlinedIcon
} from '../customStyles/images';

export const ICON_LIST = {
  // EditOutlinedIcon,
  // DeleteOutlinedIcon,
  // SettingsOutlinedIcon,
  // FileUploadOutlinedIcon,
  // CheckCircleOutlinedIcon,
  // PendingOutlinedIcon,
  // ErrorOutlineOutlinedIcon,
  // HelpOutlinedIcon,
  // LinkOutlinedIcon,
  // LinkOffOutlinedIcon,
  // InfoOutlinedIcon
}

/**
 * Table Basic Settings 
 */
export const TABLE_ROWS = 10;
export const TABLE_HEAD_HEIGHT = 42;
export const TABLE_ROWS_HEIGHT_TWO = 64;
export const TABLE_ROWS_HEIGHT_SINGLE = 34.5;